<template>
  <div class="" style="position: relative;">
    <v-toolbar>
      <v-toolbar-title>マップ生成ツール Ver1.01</v-toolbar-title>
    </v-toolbar>


    <v-dialog v-model="dialogCSV" width="800">
    <v-card class="pa-4" max-width="1200px" style="margin: 10px auto;">
      <v-card-title>CSV一括更新</v-card-title>
      <v-card-subtitle>設定済みのマップデータを一括で更新できます</v-card-subtitle>
      <v-card-text>
       <div class="pt-1 pb-5">
        ※差分更新（あるマップの一部の座標だけ更新）はできないので注意してください。例えば指定したマップの一部だけのデータを含んだCSVをアップロードすると、CSVに登録されているデータのみ更新されます。
        CSVで登録するときは、<span class="yellow">すべての座標データを含めたCSVでアップロード</span>してください。
       </div>

        <label>
          <input type="file" @change="loadCsvFile($event)" /><span
            style="color:red;font-size:12px;padding-left:10px;">（CSVファイル読み込み）</span>
        </label>

        <div class="py-2">
        <v-progress-linear :value="progress" height="14" color="orange"></v-progress-linear>
        </div>
       <div v-html="progress_message"></div>
      </v-card-text>

      <v-card-actions>
        <v-btn @click="dialogCSV = false" outlined>閉じる</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>


    <v-card class="pa-4" max-width="1200px" style="margin: 10px auto;">
      <v-container class="ma-0">
        <v-row class="align-center">
          <v-col cols="8">

          </v-col>


          <v-col cols="2" style="text-align:right;">
      

          </v-col>
          <v-col cols="2" style="text-align:right">


          </v-col>
        </v-row>
      </v-container>

      <div class="d-flex align-center">
        <div class="pa-2" style="width:70%">
          <v-text-field label="検索" prepend-inner-icon="mdi-magnify" v-model="search" style="width:500px" clearable outlined rounded
          placeholder="親マップのみ検索できます。" hide-details="true" @change="saveSearch"></v-text-field>
        </div>

        <div>
          <v-btn color="primary" class="pa-6 mr-4" @click="detail('new', false)" style="font-size: 16px !important;">
              <svg class="pr-2" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="#fff" d="M11 13H6q-.425 0-.712-.288T5 12t.288-.712T6 11h5V6q0-.425.288-.712T12 5t.713.288T13 6v5h5q.425 0 .713.288T19 12t-.288.713T18 13h-5v5q0 .425-.288.713T12 19t-.712-.288T11 18z"/></svg>
              新規登録</v-btn>

        <v-btn color="orange" class="pa-6" @click="dialogCSV = true" style="font-size: 16px !important;color:#fff;">
              <svg class="pr-2" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><g fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" color="#888888"><path d="M3.5 13v-.804c0-2.967 0-4.45.469-5.636c.754-1.905 2.348-3.407 4.37-4.118C9.595 2 11.168 2 14.318 2c1.798 0 2.698 0 3.416.253c1.155.406 2.066 1.264 2.497 2.353c.268.677.268 1.525.268 3.22V13"/><path d="M3.5 12a3.333 3.333 0 0 1 3.333-3.333c.666 0 1.451.116 2.098-.057a1.67 1.67 0 0 0 1.179-1.18c.173-.647.057-1.432.057-2.098A3.333 3.333 0 0 1 13.5 2m-6 15.22C7.445 16.03 6.622 16 5.505 16c-1.72 0-2.005.406-2.005 2v2c0 1.594.285 2 2.005 2c1.117 0 1.94-.03 1.995-1.22m13-4.78l-1.777 4.695c-.33.87-.494 1.305-.755 1.305c-.26 0-.426-.435-.755-1.305L15.436 16m-2.56 0h-1.18c-.473 0-.709 0-.895.076c-.634.26-.625.869-.625 1.424s-.009 1.165.625 1.424c.186.076.422.076.894.076s.708 0 .894.076c.634.26.625.869.625 1.424s.009 1.165-.625 1.424c-.186.076-.422.076-.894.076H10.41"/></g></svg>
              一括更新</v-btn>

        </div>



      </div>


      <div class="d-flex align-center" style="height: 50px">
        <!-- <v-checkbox class="pr-5 ml-4" @change="(flg) => allselect(flg)" label="表示中の項目をまとめて選択"></v-checkbox> -->
        <v-btn  :disabled="checkData.length == 0" color="green" class="pa-4 white--text" @click="csvSelectDownload()">CSV一括ダウンロード</v-btn>
        <div class="pl-4" style="flex: 1;width: 200px;" v-html="dispCheckDat(checkData)"></div>
      </div>

      <v-divider class="mt-2"></v-divider>

      <v-overlay :absolute="absolute" :value="overlay" :opacity="opacity">
        <v-progress-circular indeterminate color="green"></v-progress-circular>
      </v-overlay>


      <v-data-table :headers="headers" :items="main_items" :items-per-page="itemsPerPage"
        @update:items-per-page="updateItemsPerPage" :footer-props="{ itemsPerPageOptions: [25, 50, 100, -1] }" sort-desc
        fixed :search="search" :page="page"
        show-select
        item-key="id"
        v-model="checkData"
        class="map_list_table"
        >





      <template v-slot:item.name="{ item  }">

        <table width="100%" class="remove">
          <tr>
            <td width="70%">
              <v-btn outlined class="transparent" @click="detail(item.id, false)">
                <v-icon small color="primary">fas fa-edit</v-icon>
              </v-btn>
              {{ item.name }}
            </td>
            <td width="10%">
              <span outlined class="transparent text-blue" style="color: #2196F3;font-weight: bold;cursor: pointer;"
                @click="moveMapInfo(item.slug)">{{ item.slug }}
              </span>

            </td>

            <td width="10%">

            <v-btn outlined class="transparent" style="color: #2196F3;font-weight: bold;"
              @click="moveMappingList(item.id, false)">設定一覧
            </v-btn>
            </td>
            <td width="10%">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn outlined color="blue" dark v-bind="attrs" v-on="on">
                    <v-icon small color="primary" class="">fas fa-caret-down</v-icon>
                  </v-btn>
                </template>
                <v-list class="menu">
                  <v-list-item dense>
                    <v-list-item-title>
                      <v-btn color="white" @click="detail(item.id, true)">コピーして作成</v-btn></v-list-item-title>
                  </v-list-item>
                  <v-list-item dense>
                    <v-list-item-title>
                      <v-btn width="100%" color="white"
                        @click="subdetail(-1, item.id, true)">分割編集</v-btn></v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>

          </tr>

          <tr v-for="child in sub_items[item.id]" v-bind:key="item.id + '_' + child.id">
            <td  width="70%">
              <span style="padding-left: 40px;">└</span>
              <v-btn outlined class="transparent pl-1" @click="subdetail(child.id, child.parent_id, false)">
                <v-icon small color="primary">fas fa-edit</v-icon></v-btn>{{ child.id }}. {{ child.name }}
            </td>
            <td width="10%"></td>
            <td width="10%"> <v-btn outlined class="transparent text-blue" style="color: #2196F3;font-weight: bold;"
                @click="moveMappingListSub(child.id, child.parent_id, false)">設定一覧
              </v-btn>
            </td>
            
            <td width="10%">
              <v-btn outlined style="color:#888" class="transparent"
                @click="subdelete(child.parent_id, child.id, child.name)"><v-icon small color="">fas fa-trash</v-icon>
              </v-btn>
            </td>
          </tr>

        </table>


      

      </template>



      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import getMapList from "@/plugins/mapping_list";
import generateMapCSV from "@/plugins/mapping_csv";
import convertObjectToCSV from "@/plugins/convert_to_object_csv";
import mapCsvRead from "@/plugins/mapping_csv_read";




export default {
  name: "MapGenerateList",
  components: {},
  data() {
    return {
      absolute: true,
      opacity: 0.1,
      overlay: true,

      dialogCSV: false,

      page: 1,
      itemsPerPage: 25,

      progress: 0,
      progress_message: "",

      headers: [


        {
          text: "ID",
          align: "center",
          value: "id",
          sortable: false,
          width: "60px",
        },

        {
          text: "　保存名",
          align: "left",
          value: "name",
          sortable: false,
        },
        // {
        //   text: "",
        //   align: "right",
        //   value: "name",
        //   sortable: false,
        //   width: "90px",
        // },

        // {
        //   text: "",
        //   align: "left",
        //   value: "name",
        //   sortable: false,
        //   width: "100px",
        // },
      ],
      main_items: [],
      sub_items: [],

      search: "",

      checkData: [],
    };
  },
  mounted() {
    var self = this;

    this.search = localStorage.getItem("map_search") || "";
    if (this.search == "null") {
      this.search = "";
    }

    axios
      .get(process.env.VUE_APP_MAP_LIST, {
        data: "",
      })
      .then(function (response) {
        self.main_items = response.data["main"];
        self.sub_items = response.data["sub"];

        // console.log(self.main_items);
      })
      .finally(function () {
        self.overlay = false;
      });
  },

  computed: {},

  watch: {},

  methods: {

    async loadCsvFile(e) {
      //1.CSVの読み込み
      let csv_data = await mapCsvRead(e)

      //メインID一覧を格納
      let map_ids = [];
      let map_data = {};

      //更新用のマーカーデータ
      let marker_data = {};

      let self = this


      console.log("======処理1=====")

      //2.マップIDを抽出（ サブIDをチェック)
      csv_data.forEach(v => {

        if (v.map_id == "") {
          return
        }

        if (map_ids.indexOf(v.map_id) === -1) {
          map_ids.push(v.map_id)
        }

        if (!map_data[v.map_id]) {
          map_data[v.map_id] = [];
          marker_data[v.map_id] = {};
        }

        const target_img_no = v.img_no;
        if (!marker_data[v.map_id][target_img_no]) {
          marker_data[v.map_id][target_img_no] = [];
        }

        map_data[v.map_id].push(v);
        marker_data[v.map_id][target_img_no].push(v);

        console.log("======処理2=====", v)


      });


      console.log("======処理3=====")

      // let update_sub_ids = []
      let updateItemSub = {};


      let data_count = map_ids.length
      let count = 1;

      for (const map_id of map_ids) {
        console.log("======処理4=====", map_id)

        this.progress = (count / data_count) * 100;
        ++count;

        //保存済みのマップデータを取得
        const result = await getMapList(map_id);
        let saveContent = result.map_data


        //CSVから読み取ったマーカーを更新する

        for (let target_img_no in marker_data[map_id]) {
          console.log("target_img_no", marker_data[map_id][target_img_no])


          marker_data[map_id][target_img_no].forEach(checkData => {
            const csv_target_id = checkData.id
            const csv_content = checkData.content
            const csv_search_group = checkData.search_group
            const csv_label = checkData.label

            //メインマップの更新
            saveContent.markers[target_img_no].forEach((element) => {
              if (element.id == csv_target_id) {
                if (csv_content || csv_content == "") {
                  element.content = csv_content;
                }
                if (csv_search_group || csv_search_group == "") {
                  element.search_group = csv_search_group;
                }
                if (csv_label || csv_label == "") {
                  element.label = csv_label;
                }

                //サブマップデータがある場合
                if (element.sub_map_id != "" && typeof element.sub_map_id != "undefined") {
                  if (!updateItemSub[element.sub_map_id]) {
                    updateItemSub[element.sub_map_id] = {};
                  }

                  if (!updateItemSub[element.sub_map_id][element.img_no]) {
                    updateItemSub[element.sub_map_id][element.img_no] = [];
                  }
                  updateItemSub[element.sub_map_id][element.img_no].push(element);
                }
              }
            });
          });
        }

        //サブマップのIDがある場合
        for (let sub_id in updateItemSub) {
          console.log(" ****** サブマップを更新 (" + map_id + "_" + sub_id + ") ******");
          let saveData = {};
          saveData.parent_id = map_id;
          saveData.id = sub_id;
          saveData.content = {};
          saveData.content.markers = updateItemSub[sub_id];
          saveData.name = "CSV空登録"
          saveData.updata_content_only = true; //コンテンツのみ更新


          axios
            .post(process.env.VUE_APP_MAP_SUB_UPDATE, {
              data: saveData,
            })
            .then(function (response) {
              console.log("結果", response);


              self.progress_message += "マップを更新 (" + map_id + "_" + sub_id + ") ==> ";


              //新規追加
              if (
                response.data["status"] == 0 ||
                response.data["status"] == 1 ||
                response.data["status"] == 2
              ) {
                if (response.data["status"] === false) {
                  self.progress_message += "データの保存に失敗しました。";
                } else {
                  // self.update_message +=
                  //   "サブマップID" + sub_id + "のデータを更新しました。<br />";
                  self.progress_message += "<span class='red--text'>SUCESS</span><br>";

                }
              } else {
                if (response.data == "ERROR_SAME_NAME") {
                  alert("同じ保存名が存在しています。");
                } else {
                  self.progress_message += "データの更新に失敗しました。";
                }
              }
            })
            .finally(function () {
              // self.overlay = false;
            });

        }

        console.log("result", result)
        let saveData = Object.assign({}, result.master_data);
        saveData.content = saveContent;

        axios
          .post(process.env.VUE_APP_MAP_UPDATE, {
            data: saveData,
          })
          .then(function (response) {
            console.log(response);

            self.progress_message += "マップを更新 (" + map_id + ") ==> ";

            //新規追加
            if (
              response.data["status"] == 0 ||
              response.data["status"] == 1 ||
              response.data["status"] == 2
            ) {
              if (response.data["status"] === false) {
                self.progress_message += "データの更新に失敗しました。<br>";
              } else {
                // self.update_message += "データを更新しました。<br />";
                self.progress_message += "<span class='red--text'>SUCESS</span><br>";
              }
            } else {
              if (response.data == "ERROR_SAME_NAME") {
                alert("同じ保存名が存在しています。");
              } else {
                self.progress_message += "データの更新に失敗しました。<br>";
              }
            }
          })
          .finally(function () {
            // self.overlay = false;
          });
        // marker_data[map_id].forEach((target_img_no) => {

        //   console.log("target_img_no",target_img_no)
        // });


        // saveData.content.markers[target_img_no].forEach((element) => {

        // });



        //メインマップのとき


      }


      console.log("======★終了=====")

    },

    updateItemsPerPage(newItemsPerPage) {
      this.itemsPerPage = newItemsPerPage;
    },


    moveMapInfo(slug) {
      this.$router.push({
        name: "mapGroupDetail",
        params: { slug: slug },
      });
    },

    moveMappingList(page_id, copy_mode) {
      this.$router.push({
        name: "mapPositionDetail",
        params: { parent_id: page_id, copy: copy_mode },
      });
    },

    moveMappingListSub(page_id, parent_id, copy_mode) {
      this.$router.push({
        name: "mapSubPositionDetail",
        params: { id: page_id, parent_id: parent_id, copy: copy_mode },
      });
    },

    // 未使用
    // //該当マップのチェックボックス処理
    // toggleSelect(item) {
    //   let index = this.checkData.indexOf(item.id)
    //   if (index === -1) {
    //     this.checkData.push(item.id)
    //     item.check = true
    //   } else {
    //     this.checkData.splice(index, 1);
    //     item.check = false
    //   }
    // },

    // //表示中をまとめて選択
    // allselect(flg) {
    //   const startIndex = (this.page - 1) * this.itemsPerPage;
    //   const endIndex = startIndex + this.itemsPerPage;


    //   const filterItems = this.main_items.filter(item => {
    //     return (
    //       item.name.toUpperCase().includes(this.search.toUpperCase()) ||
    //       this.search == null ||
    //       this.search == "" ||
    //       typeof this.search == undefined
    //     );
    //   });



    //   const Ids = filterItems.slice(startIndex, endIndex).map(item => item.id);

    //   Ids.forEach(id => {
    //     let index = this.checkData.indexOf(id)
    //     if (flg) {
    //       if (index === -1) {
    //         this.checkData.push(id)
    //       }
    //     } else {
    //       this.checkData.splice(index, 1);
    //     }

    //   });

    //   this.main_items.forEach(item => {
    //     if (this.checkData.indexOf(item.id) !== -1) {
    //       item.check = true
    //     } else {
    //       item.check = false
    //     }
    //   });
    // },

    //選択項目の表示
    dispCheckDat(){
      let ids = []
      for (let index in this.checkData) {
        ids.push(this.checkData[index].id)
      }
      if(ids.length > 0){
        return "選択中："+ids
      }

      return ""
    },

    //CSV選択ダウンロード機能
    async csvSelectDownload() {

      let output = [];

      let file_name  = "";

      for (let index in this.checkData) {
        console.log("id=", this.checkData[index].id)
        const id = this.checkData[index].id;
        file_name += id+"_"
        const result = await getMapList(id);
        const map_data = result.map_data
        output = output.concat(await generateMapCSV(id, map_data))
      }


      console.log("出力データ", output)

      const blob = new Blob([convertObjectToCSV(output)], {
        type: "text/csv",
      });
      const url = (window.URL || window.webkitURL).createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;

      file_name +=  ".csv";


      a.download = file_name;
      document.body.appendChild(a);
      a.click();


      // self.map_data = result.map_data
      // self.map_name = result.map_name
      // self.master_data = result.master_data
      // self.sub_flg = result.sub_flg

      // console.log(map_data)


    },

    detail(page_id, copy_mode) {
      this.$router.push({
        name: "mapDetail",
        params: { id: page_id, copy: copy_mode },
      });
    },
    subdetail(page_id, parent_id, copy_mode) {
      this.$router.push({
        name: "mapSubDetail",
        params: { id: page_id, parent_id: parent_id, copy: copy_mode },
      });
    },
    subdelete(parent_id, child_id, name) {
      console.log(child_id);

      if (
        window.confirm("サブマップ「" + name + "」のデータを削除しますか？\n")
      ) {
        axios
          .post(process.env.VUE_APP_MAP_SUB_DELETE, {
            data: { parent_id: parent_id, id: child_id },
          })
          .then(function () {
            alert("削除しました。");
          })
          .finally(function () {
            location.reload();
          });
      }
    },

    saveSearch() {
      localStorage.setItem("map_search", this.search);
    },

    tableColor(index) {
      index = index + 1;
      if (index % 2 == 0) {
        return "tr_color";
      }
      return "tr_normal";
    },
  },
};
</script>
<style scoped>
.tr_color {
  background: #f5f8fe;
}

.menu .v-list-item {
  border-bottom: 1px solid #ddd;
}

.theme--light.v-list {
  padding: 0;
}

::v-deep .v-input--selection-controls__ripple {
  color: rgba(212, 219, 245, 0.77)
}

::v-deep .map_list_table  table tr:hover td{
  background: transparent !important;
}

::v-deep .map_list_table  table:not(.remove) tr:nth-child(2n) td{
  background: rgb(255, 254, 249);
}

::v-deep .map_list_table  table.remove tr td{
  background: transparent !important;
  border-top: 1px solid #ddd;
  padding: 6px
}
::v-deep .map_list_table  table.remove tr:first-child td{
  border-top: none;
}

::v-deep .theme--light.v-data-table tbody tr.v-data-table__selected td{
  background: rgb(219, 241, 205);
}

</style>
